import Tool from './Tool';
import Util from '../utils/util';
import getSymbol from '../style';

/**
 * 选择工具基类
 * @interface
 */
export default class SelectTool extends Tool {
    /**
     * 构造方法
     * @param {object} options 可选项
     */
    constructor(options = {}) {
        super({
            filter: {}, // 过滤条件，主要通过feature的属性信息过滤
            ...options
        });

        /**
         * 选中的要素
         * @type {array}
         */
        this.selectedFeatures = [];
    }

    /**
     * 添加到控制器时调用，执行数据的初始化
     * @param {object} map 地图实例
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        super.onAdd(controller);

        this._featureSelector = this._map.FeatureSelector;
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     * @param {object} map        地图实例
     * @param {object} controller 控制器实例
     */
    onRemove() {
        this._featureSelector = null;

        super.onRemove();
    }

    /**
     * 重新设置要反馈绘制的内容
     * 子类要对其进行重写
     */
    resetFeedback() {
        super.resetFeedback();

        const items = [];
        if (this.selectedFeatures.length > 0) {
            this.selectedFeatures.forEach(f => {
                items.push(...this.getHighlightItems(f, 2));
            });
        }
        if (items.length > 0) {
            this._feedback.addItems(items);
        }
    }

    /**
     * 工具操作完成时调用
     */
    finish() {
        if (Util.isFunction(this.onFinish)) {
            this.onFinish(this.selectedFeatures);
        }
    }

    /**
     * 根据要素信息获取高亮对象
     * 基类的简单高亮方法，子类可对其进行重写
     * @param {object} feature 要素实例
     * @param {number} type    高亮类型：1.蓝色；2.红色
     * @returns {array} 反馈实例可以添加的对象数组
     */
    getHighlightItems(feature, type) {
        const geom = feature.geometry;
        let symbol;
        switch (geom.type) {
            case 'Point':
                if (type === 1) {
                    symbol = getSymbol('hover_pt');
                } else {
                    symbol = getSymbol('selected_pt');
                }
                
                break;
            case 'LineString':
                if (type === 1) {
                    symbol = getSymbol('hover_ls');
                } else {
                    symbol = getSymbol('selected_ls');
                }
                break;
            default:
                if (type === 1) {
                    symbol = getSymbol('hover_pg');
                } else {
                    symbol = getSymbol('selected_pg');
                }
                break;
        }

        return [{
            geometry: geom,
            symbol
        }];
    }
}
